import { configureStore } from '@reduxjs/toolkit';
import LayoutReducer from './reducers/Layout/LayoutReducer';
import ProductReducer from './reducers/ECommerce/ProductReducer';
import FilterReducer from './reducers/ECommerce/FilterReducer';
import TodoReducer from './reducers/TodoReducer';
import SearchResultReducer from './reducers/SearchResultReducer';
import ContactReducer from './reducers/ContactReducer';
import TasksReducer from './reducers/TasksReducer';
import UsersReducer from './reducers/UsersReducer';
import BookmarkReducer from './reducers/BookmarkReducer';
import EmailReducer from './reducers/LetterBoxReducer';
import ChatReducer from './reducers/ChatReducer';
import ProjectReducer from './reducers/ProjectReducer';
import JobSearchReducer from './reducers/JobSearchReducer';
import ThemeCustomizerReducer from './reducers/Layout/ThemeCustomizerReducer';
import AuthReducer from './reducers/auth/AuthReducer';
import LoanRequestReducer from './reducers/loanRequest/LoanRequestReducer';

export const store = configureStore({
   reducer: {
      auth: AuthReducer,
      LoanRequest: LoanRequestReducer,
      layout: LayoutReducer,
      product: ProductReducer,
      filter: FilterReducer,
      todos: TodoReducer,
      searchResult: SearchResultReducer,
      contact: ContactReducer,
      tasks: TasksReducer,
      email: EmailReducer,
      chat: ChatReducer,
      project: ProjectReducer,
      jobSearch: JobSearchReducer,
      userCards: UsersReducer,
      bookmark: BookmarkReducer,
      themeCustomizer: ThemeCustomizerReducer,
   },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
